/** 제휴사 관리 API (8-1) 요청 DTO */

export interface getPartnerListForm {
  page: number
  size: number
}

/**
 * 제휴사 유형 코드 — GET /v1/partner/type 에서 코드·표시명을 받는다.
 * REFERENCE 가 공통 비교용 백업 제휴사(구 isBackup=true). 새 코드가 추가될 수 있어 string 도 허용
 */
export type PARTNER_TYPE =
  | 'PHONE_ONLY'
  | 'PHONE_COMPARE'
  | 'USIM_ONLY'
  | 'USIM_COMPARE'
  | 'ALL_ONLY'
  | 'ALL_COMPARE'
  | 'REFERENCE'
  | (string & {})

/** POST /v1/partner, PATCH /v1/partner/{partnerId} 공통 바디 */
export interface partnerForm {
  partnerName: string
  /** YYYY-MM-DD */
  activeFrom: string
  /** YYYY-MM-DD */
  activeTo: string
  /** 어드민이 켜둔 활성화 설정 — 실제 활성 여부(isActive)는 서버가 checkActive && 기간으로 계산 */
  checkActive: boolean
  /** 연결 링크 path (ex. opgg) */
  link: string
  /** 상담 링크 */
  contactLink: string
  /** 제휴사 유형 (필수) — isBackup 을 대체. 빈 값은 미선택 */
  partnerType: PARTNER_TYPE | ''
  /** 공급업체(지점) id — GET /v1/partner/store 항목의 id. 없으면 null */
  referenceStoreId: number | null
}

export const initPartnerForm: partnerForm = {
  partnerName: '',
  activeFrom: '',
  activeTo: '',
  checkActive: false,
  link: '',
  contactLink: '',
  partnerType: '',
  referenceStoreId: null,
}

/**
 * 유저향 제휴 페이지 URL — link(slug) 를 붙여서 만든다.
 * ex) moongcheap → https://modusj.com/historyStore/moongcheap
 * 유심 전용(USIM_ONLY) 제휴사는 유심 랜딩(/partner/{link}) 으로 들어간다
 */
export const PARTNER_PAGE_BASE_URL = 'https://modusj.com/historyStore'
export const PARTNER_USIM_PAGE_BASE_URL = 'https://modusj.com/partner'
export const partnerPageUrl = (link: string | null | undefined, partnerType?: PARTNER_TYPE | null) => {
  if (!link) return ''
  const base = partnerType === 'USIM_ONLY' ? PARTNER_USIM_PAGE_BASE_URL : PARTNER_PAGE_BASE_URL
  return `${base}/${link}`
}

/** POST /v1/partner/{partnerId}/upload — 제휴사 이미지 업로드/삭제 (PROFILE=로고, BANNER=배너, SHARE=카카오톡 공유) */
export type PARTNER_IMAGE_TYPE = 'BANNER' | 'PROFILE' | 'SHARE'
export interface partnerImageUploadForm {
  partnerId: number | string
  imageType: PARTNER_IMAGE_TYPE
  /** 업로드할 파일 (multipartFile). delete=true 면 생략 */
  file?: File | null
  /** true 면 해당 이미지 삭제 */
  delete?: boolean
}

/** GET /v1/partner/quotation/reference/{storeId} 쿼리 */
export interface partnerQuotationReferenceForm {
  storeId: number | string
  /** 주요폰 최종금액 일괄 가감 사용 여부 */
  useMain?: boolean
  /** 주요폰 최종금액 일괄 가감 (만원, 소수점 한 자리) — 비우면 원본 그대로 */
  addMain?: number
  /** 키즈폰 최종금액 일괄 가감 사용 여부 */
  useKids?: boolean
  /** 키즈폰 최종금액 일괄 가감 (만원, 소수점 한 자리) */
  addKids?: number
  /** 유심 페이백 일괄 가감 사용 여부 */
  useUsim?: boolean
  /** 유심 페이백 일괄 가감 (만원, 소수점 한 자리) */
  addUsim?: number
  /** 부가서비스도 함께 불러올지 */
  useAddService?: boolean
}
